import { CloseButton, type CloseButtonProps } from '@mantine/core'
import React, { useContext } from 'react'

import { ModalsContext } from './ModalsProvider'
import classes from './styles.module.css'

export function Close(props: CloseButtonProps) {
  const { closeModal } = useContext(ModalsContext)

  return (
    <CloseButton
      onClick={() => closeModal()}
      className={classes.close}
      {...props}
    />
  )
}

Close.displayName = 'ModalClose'
